/**
 * Completion source labels for administrative recovery task carousel.
 */

import type { RecoveryStoreTaskDto } from './admin-recovery-types.js';

export const RECOVERY_TASK_COMPLETION_SOURCES = [
  'admin_complete',
  'admin_rejected',
  'operator_synced',
  'locked',
  'needs_admin_action',
] as const;

export type RecoveryTaskCompletionSource = (typeof RECOVERY_TASK_COMPLETION_SOURCES)[number];

export function getRecoveryTaskCompletionSource(
  task: Pick<
    RecoveryStoreTaskDto,
    'status' | 'hasActiveOverride' | 'operatorProgress'
  >,
): RecoveryTaskCompletionSource {
  if (task.status === 'admin_rejected') {
    return 'admin_rejected';
  }
  if (task.status === 'locked') {
    return 'locked';
  }
  if (task.status === 'admin_complete' || task.hasActiveOverride) {
    return 'admin_complete';
  }
  if (task.operatorProgress?.hasOperatorSubmission) {
    return 'operator_synced';
  }
  return 'needs_admin_action';
}

/** Task still requires admin on-behalf completion (no operator sync, not admin-resolved). */
export function taskNeedsAdminRecoveryAction(
  task: Pick<
    RecoveryStoreTaskDto,
    'status' | 'hasActiveOverride' | 'operatorProgress'
  >,
): boolean {
  return getRecoveryTaskCompletionSource(task) === 'needs_admin_action';
}

export const RECOVERY_COMPLETION_SOURCE_LABELS: Record<RecoveryTaskCompletionSource, string> = {
  admin_complete: 'Admin',
  admin_rejected: 'Rejected',
  operator_synced: 'Operator',
  locked: 'Locked',
  needs_admin_action: 'Needs action',
};

export function recoveryCompletionSourceLabel(source: RecoveryTaskCompletionSource): string {
  return RECOVERY_COMPLETION_SOURCE_LABELS[source];
}
